import React from "react"
import Modal from "Modal"
import Button from "Button"
import Select from "Select"
import { fromPairs } from "lodash"
import Flash from "flash"
import request from "request"

const TerminalReassignModal = ({
  isOpen,
  onClose,
  stores,
  terminal,
}) => {
  const [selectedStore, setSelectedStore] = React.useState(null)
  const [loading, setLoading] = React.useState(false)

  const handleReassign = () => {
    if (!selectedStore) return
    setLoading(true)
    const req = request.patch(`terminals/${terminal.id}/reassign`, { storeId: selectedStore })
    req.then(({data}) => {
      Flash.broadcast("success", "Terminal Reassigned.")
      onClose()
      setLoading(false)
    })
    req.catch(() => {
      Flash.broadcast("error", "There was an issue reassigning this terminal")
      setLoading(false)
    })
  }

  return (
    <Modal
      title="Reassigning Terminal"
      isOpen={isOpen}
      toggleModal={onClose}
      actions={
        <>
          <span className="button is-outline ml-auto" onClick={onClose}>Cancel</span>
          <Button
            disabled={!selectedStore}
            loading={loading}
            onClick={handleReassign}
            text="Reassign"
          />
        </>
      }
    >
      <div>
        <p className="is-size-5">
          Reassigning&nbsp;
          {[
            terminal?.store?.name,
            terminal?.number,
          ].join(" #")}
        </p>
        <Select
          prompt={"Select a Store"}
          options={fromPairs(stores.map((s) => [ s.id, s.name ]))}
          onChange={setSelectedStore}
          value={selectedStore}
          className="mt-2"
        />
      </div>
    </Modal>
  )
}

export default TerminalReassignModal
